import {useEffect, useState} from "react";
import {useSupportCase} from "../support/CaseHook";
// python:
//     @dataclass
//     class Period:
//         start_time: datetime
//         end_time: datetime
interface Period {
    start_time: string
    end_time: string
}


interface LicenseInfo {
    limit: number
    usage: number
    period: Period
    overage_allowed: boolean
    cancel_at?: string
    remaining?: number
}
export const LicenseUsageTracker = () => {
    const [remaining, setRemaining] = useState<number | undefined>(undefined)
    const {fetchData} = useSupportCase()
    useEffect(() => {
        const fetchLicenseInfo = async () => {
            console.log(`Fetching license info ...`)
            const response = await fetchData("/api/license/usage/", "GET")
            const usage = await response.json() as LicenseInfo
            console.log(`Fetched license usage info: ${JSON.stringify(usage)}`)
            if (remaining != usage.remaining) {
                console.log(`Updating remaining license usage from ${remaining} to ${usage.remaining}`)
                setRemaining(usage.remaining)
            } else {
                console.log(`Remaining license usage unchanged: ${remaining}`)
            }
        }
        console.log("Fetching license info immediately on component mount")
        fetchLicenseInfo()
        console.log("Setting up interval to fetch license info every 360 seconds")
        // const id = setInterval(fetchLicenseInfo, 360_000)
        // return () => {
        //     console.log("Clearing previous interval on component unmount")
        //     clearInterval(id)
        // }
    }, [fetchData, remaining])

    useEffect(() => {
        console.log("Remaining changed: ", remaining)
    }, [remaining]);

    useEffect(() => {
        console.log("fetchData changed: ", fetchData)
    }, [fetchData]);

    console.log(`Rendering LicenseUsageTracker with remaining: ${remaining}`)
    if (remaining == null) {
        return null
    }
    if (remaining <= 0) {
        return <div className="bg-red-500 w-fit text-gray-500 text-left text-xs px-4">
            <p>License extension is required</p>
        </div>
    }
    return null
}